import moment from "moment";

const getGeneralInfoChangesLog = (oldData, newData, changedBy) => {
  const KEYS_TEXT = {
    signupDate: "Date",
    agent: "Agent",
    currentProvider: "Current Provider",
    title: "Title",
    name: "Customer Name",
    designation: "Designation",
    email: "Customer Email",
    mobileNo: "Mobile Number",
    businessName: "Business Name",
    businessType: "Business Type",
    address1: "1st Line of Phone Number Address",
    address2: "2nd Line of Phone Number Address",
    town: "Town",
    city: "City",
    postCode: "Post Code",
    billingEmail: "Billing Email",
    secondName: "Add Customer",
    liveDate: "Live Date",
    isAddCustomer: "Add Customer Option",
    eBilling: "E-Billing",
    accountNo: "Account No",
    note: "Notes",
  };

  let changes = [];

  Object.keys(newData).forEach((key) => {
    if (oldData[key] !== newData[key]) {
      let oldValue = oldData[key] || "Empty";
      let newValue = newData[key] || "Empty";
      let message = `${KEYS_TEXT[key]} changed from ${oldValue} to ${newValue}`;

      if (key === "isAddCustomer") {
        if (!oldData[key] && newData[key]) {
          message = "Add Customer Option changed from None to Selected";
        } else if (oldData[key] && !newData[key]) {
          message = "Add Customer Option changed from Selected to None";
        }
      }

      changes.push({
        section: "General Information",
        field: key,
        oldValue,
        newValue,
        message,
        timestamp: Date.now(),
        changedBy,
      });
    }
  });

  return changes;
};

const getDownlaodSpeedChangesLog = (oldData, newData, changedBy) => {
  const KEYS_TEXT = {
    min: "Minimum Download Speed",
    max: "Maximum Download Speed",
  };

  let changes = [];

  Object.keys(newData).forEach((key) => {
    if (oldData[key] !== newData[key]) {
      changes.push({
        section: "Download Speed",
        field: key,
        oldValue: oldData[key] || "Empty",
        newValue: newData[key] || "Empty",
        message: `${KEYS_TEXT[key]} changed from ${
          oldData[key] || "Empty"
        } to ${newData[key] || "Empty"}`,
        timestamp: Date.now(),
        changedBy,
      });
    }
  });

  return changes;
};
const getUploadSpeedChangesLog = (oldData, newData, changedBy) => {
  const KEYS_TEXT = {
    min: "Minimum Upload Speed",
    max: "Maximum Upload Speed",
  };

  let changes = [];

  Object.keys(newData).forEach((key) => {
    if (oldData[key] !== newData[key]) {
      changes.push({
        section: "Upload Speed",
        field: key,
        oldValue: oldData[key] || "Empty",
        newValue: newData[key] || "Empty",
        message: `${KEYS_TEXT[key]} changed from ${
          oldData[key] || "Empty"
        } to ${newData[key] || "Empty"}`,
        timestamp: Date.now(),
        changedBy,
      });
    }
  });

  return changes;
};

const getRouterChangesLog = (oldData, newData, changedBy) => {
  const KEYS_TEXT = {
    costType: "Router Cost Type",
    value: "No. of Routers",
    price: "Router Cost",
    isUpgrade: "Router Upgrade",
  };

  let changes = [];

  Object.keys(newData).forEach((key) => {
    if (oldData[key] !== newData[key]) {
      const isPrice = key === "price";

      const formattedOldValue = isPrice ? `£${oldData[key]}` : oldData[key];
      const formattedNewValue = isPrice ? `£${newData[key]}` : newData[key];

      changes.push({
        section: "No. of Routers",
        field: key,
        oldValue: oldData[key],
        newValue: newData[key],
        message: `${KEYS_TEXT[key]} changed from ${formattedOldValue} to ${formattedNewValue}`,
        timestamp: Date.now(),
        changedBy,
      });
    }
  });

  return changes;
};

const getCordedChangesLog = (oldData, newData, changedBy) => {
  const KEYS_TEXT = {
    costType: "Corded Phone Cost Type",
    value: "No. of Corded Phone",
    price: "Corded Phone Cost",
  };

  let changes = [];

  Object.keys(newData).forEach((key) => {
    if (oldData[key] !== newData[key]) {
      const isPrice = key === "price";

      const formattedOldValue = isPrice ? `£${oldData[key]}` : oldData[key];
      const formattedNewValue = isPrice ? `£${newData[key]}` : newData[key];

      changes.push({
        section: "Corded Phones",
        field: key,
        oldValue: oldData[key],
        newValue: newData[key],
        message: `${KEYS_TEXT[key]} changed from ${formattedOldValue} to ${formattedNewValue}`,
        timestamp: Date.now(),
        changedBy,
      });
    }
  });

  return changes;
};

const getCordedlessChangesLog = (oldData, newData, changedBy) => {
  const KEYS_TEXT = {
    costType: "Cordless Phone Cost Type",
    value: "No. of Cordless Phone",
    price: "Cordless Phone Cost",
  };

  let changes = [];

  Object.keys(newData).forEach((key) => {
    if (oldData[key] !== newData[key]) {
      const isPrice = key === "price";

      const formattedOldValue = isPrice ? `£${oldData[key]}` : oldData[key];
      const formattedNewValue = isPrice ? `£${newData[key]}` : newData[key];

      changes.push({
        section: "Cordless Phones",
        field: key,
        oldValue: oldData[key],
        newValue: newData[key],
        message: `${KEYS_TEXT[key]} changed from ${formattedOldValue} to ${formattedNewValue}`,
        timestamp: Date.now(),
        changedBy,
      });
    }
  });

  return changes;
};

const getEquipmentChangesLog = (oldData, newData, changedBy) => {
  const KEYS_TEXT = {
    value: "Euipments",
    price: "Euipments price",
    costType: "Equipment Cost Type",
  };

  let changes = [];

  Object.keys(newData).forEach((key) => {
    if (key !== "type") {
      if (oldData[key] !== newData[key]) {
        const isPrice = key === "price";

        const formattedOldValue = isPrice ? `£${oldData[key]}` : oldData[key];
        const formattedNewValue = isPrice ? `£${newData[key]}` : newData[key];

        changes.push({
          section: "Other Equipment",
          field: key,
          oldValue: oldData[key] || "Empty",
          newValue: newData[key] || "Empty",
          message: `${KEYS_TEXT[key]} changed from ${formattedOldValue} to ${formattedNewValue}`,
          timestamp: Date.now(),
          changedBy,
        });
      }
    }
  });

  return changes;
};

const ebillingChangesLog = (oldData, newData, changedBy) => {
  const KEYS_TEXT = {
    town: "Town",
    city: "City",
    postCode: "Post Code",
    address1: "1st Line of Paper Billing Address",
    address2: "2nd Line of Paper Billing Address",
  };

  let changes = [];

  Object.keys(newData).forEach((key) => {
    if (oldData[key] !== newData[key]) {
      changes.push({
        section: "Paper Billing Address",
        field: key,
        oldValue: oldData[key] || "Empty",
        newValue: newData[key] || "Empty",
        message: `In Paper Billing Address
              ${KEYS_TEXT[key]} changed from ${oldData[key] || "Empty"} to ${
          newData[key] || "Empty"
        }`,
        timestamp: Date.now(),
        changedBy,
      });
    }
  });

  return changes;
};

const debitDetailsChangesLog = (oldData, newData, changedBy) => {

  let changes = [];

  if (oldData.initial === true && newData.initial === false) {
    changes.push({
      section: "Add Direct Debit Details",
      field: "isReqDebitDetail",
      oldValue: "Yes",
      newValue: "No",
      message: `Add Direct Debit Details Option changed from Yes to No`,
      timestamp: Date.now(),
      changedBy,
    });
  } else if (oldData.initial === false && newData.initial === true) {
    changes.push({
      section: "Add Direct Debit Details",
      field: "isReqDebitDetail",
      oldValue: "No",
      newValue: "Yes",
      message: `Add Direct Debit Details Option changed from No to Yes`,
      timestamp: Date.now(),
      changedBy,
    });
  }

  return changes;
};

const debitDetailsValueChangesLog = (oldData, newData, changedBy) => {
  const KEYS_TEXT = {
    username: "Name of Account Holder",
    accountNumber: "Account Number",
    shortCode: "Sort Code",
    address: "Name and Address of Bank/Building Society",
  };

  let changes = [];

  Object.keys(newData).forEach((key) => {
    if (oldData[key] !== newData[key]) {
      changes.push({
        section: "Direct Debit Details",
        field: key,
        oldValue: oldData[key] || "Empty",
        newValue: newData[key] || "Empty",
        message: `In Direct Debit Details ${KEYS_TEXT[key]} changed from ${
          oldData[key] || "Empty"
        } to ${newData[key] || "Empty"}`,
        timestamp: Date.now(),
        changedBy,
      });
    }
  });

  return changes;
};

const upfrontPaymentChangesLog = (oldData, newData, changedBy) => {
  let changes = [];

  Object.keys(newData).forEach((key) => {
    if (oldData[key] !== newData[key]) {
      changes.push({
        section: "Upfront Payment Collected",
        field: key,
        oldValue: oldData[key] || "Empty",
        newValue: newData[key] || "Empty",
        message: `Upfront payment option changed from ${
          oldData[key] || "None"
        } to ${newData[key] || "None"}`,
        timestamp: Date.now(),
        changedBy,
      });
    }
  });

  return changes;
};

const followUpAndEndDateChangesLog = (oldData, newData, changedBy) => {

  const KEYS_TEXT = {
    end: "Contract End Date",
    follow: "Follow Up Date",
  };

  let changes = [];

  Object.keys(newData).forEach((key) => {
    if (oldData[key] !== newData[key]) {
      changes.push({
        section: "Contract End Date and Follow Up Date",
        field: key,
        oldValue: oldData[key] || "Empty",
        newValue: newData[key] || "Empty",
        message: `${KEYS_TEXT[key]} changed from ${
          oldData[key] || "Empty"
        } to ${newData[key] || "Empty"}`,
        timestamp: Date.now(),
        changedBy,
      });
    }
  });

  return changes;
};

const MAIN_KEY = {
  mobileNo: "CLI Phone Number",
  cliNumber: "CLI Option",
  line: "No of Line",
};

const comparePrimitiveValues = (oldItem, newItem, line, changedBy, index) => {
  let changes = [];

  Object.keys(newItem).forEach((key) => {
    if (typeof newItem[key] !== "object" && oldItem[key] !== newItem[key]) {
      let message = `CLI Box ${index}: ${MAIN_KEY[key] || key} changed from ${
        oldItem[key] || "None"
      } to ${newItem[key] || "None"}`;

      // Special case for cliNumber
      if (key === "cliNumber") {
        message = `CLI Box ${index}: ${MAIN_KEY[key]} changed from ${
          oldItem[key] ? "Selected" : "Not Selected"
        } to ${newItem[key] ? "Selected" : "Not Selected"}`;
      }

      changes.push({
        cliBox: index,
        section: `Cli Box ${index}`,
        field: key,
        oldValue: oldItem[key] || "None",
        newValue: newItem[key] || "None",
        message,
        timestamp: Date.now(),
        changedBy,
      });
    }
  });

  return changes;
};

// ✅ Function to compare nested objects (like legacyTariff, transfer, etc.)
const compareNestedObjects = (oldItem, newItem, line, changedBy, index) => {
  let changes = [];

  const NEXXXX = {
    attachedValue: "Attached Value",
    isSelected: "Option",
    salePrice: "Price",
    timePeriod: "Time Period",
    upPayment: "Upfront Payment",
    value: "Value",
    isImmediate: "Immediate Option",
    liveDate: "Live Date",

    // "legacyTariff.isSelected": "Legacy Option",
    // "digitalTariff.isSelected": "Digital/NGN Option",
    // "additionalService.isSelected": "Additional Services",
    // "differentAddress.isSelected": "Different Address Option",

    // "migration.isSelected": "Migration Option",
    // "migration.attachedValue": "Migration Attached Value",
    // "migration.salePrice": "Migration Price",
    // "migration.timePeriod": "Migration Timeperiod",
    // "migration.upPayment": "Migration Upfront payment",

    // "upgradeCharge.isSelected": "Upgrade Charge",
    // "upgradeCharge.attachedValue": "Migration Attached Value",
    // "upgradeCharge.salePrice": "Migration Price",
    // "upgradeCharge.timePeriod": "Migration Timeperiod",
    // "upgradeCharge.upPayment": "Migration Upfront payment",

    // "transfer.isSelected": "Transfer Option",
    // "transfer.attachedValue": "Transfer Attached Value",
  };

  Object.keys(newItem).forEach((key) => {
    if (key === "lineValues") return;
    if (typeof newItem[key] === "object" && newItem[key] !== null) {
      if (oldItem[key]) {
        // Compare each key inside the object
        Object.keys(newItem[key]).forEach((subKey) => {
          if (oldItem[key][subKey] !== newItem[key][subKey]) {
            let oldValue = oldItem[key]?.[subKey];
            let newValue = newItem[key]?.[subKey];

            let message = `CLI Box ${index}: ${newItem[key].title} ${
              NEXXXX[subKey]
            }  changed from ${
              oldValue === null || oldValue === undefined ? "None" : oldValue
            } to ${
              newValue === null || newValue === undefined ? "None" : newValue
            }`;

            changes.push({
              cliBox: index,
              section: `Cli Box ${index}`,
              field: `${key}.${subKey}`,
              oldValue: oldItem[key][subKey] || "None",
              newValue: newItem[key][subKey] || "None",
              message,
              timestamp: Date.now(),
              changedBy,
            });
          }
        });
      }
    }
  });

  return changes;
};

const compareLineValues = (oldData, newData) => {
  let changes = [];

  oldData.forEach((oldItem, index) => {
    let newItem = newData[index];

    if (!newItem) return;

    oldItem.lineValues.forEach((oldLine, lineIndex) => {
      let newLine = newItem.lineValues[lineIndex];

      if (!newLine) return;

      // ✅ Compare Legacy Tariff
      if (oldLine.legacy && newLine.legacy) {
        let legacyChanges = [];

        if (oldLine.legacy.value !== newLine.legacy.value) {
          legacyChanges.push(
            `value changed from '${oldLine.legacy.value}' to '${newLine.legacy.value}'`
          );
        }

        if (oldLine.legacy.salePrice !== newLine.legacy.salePrice) {
          legacyChanges.push(
            `salePrice changed from ${oldLine.legacy.salePrice} to ${newLine.legacy.salePrice}`
          );
        }

        if (legacyChanges.length > 0) {
          changes.push({
            cliBox: oldItem.line,
            section: `CLI Box ${oldItem.line} - Line ${lineIndex + 1}`,
            field: `lineValues[${lineIndex}].legacy`,
            oldValue: oldLine.legacy,
            newValue: newLine.legacy,
            message: `CLI Box ${oldItem.line} - Line ${
              lineIndex + 1
            }: ${legacyChanges.join(", ")}`,
            timestamp: Date.now(),
            changedBy: "Sales Agent",
          });
        }
      }

      // ✅ Compare NGN Tariff
      if (oldLine.ngnValue && newLine.ngnValue) {
        let ngnChanges = [];

        if (oldLine.ngnValue.value !== newLine.ngnValue.value) {
          ngnChanges.push(
            `value changed from '${oldLine.ngnValue.value}' to '${newLine.ngnValue.value}'`
          );
        }

        if (oldLine.ngnValue.salePrice !== newLine.ngnValue.salePrice) {
          ngnChanges.push(
            `salePrice changed from ${oldLine.ngnValue.salePrice} to ${newLine.ngnValue.salePrice}`
          );
        }

        if (ngnChanges.length > 0) {
          changes.push({
            cliBox: oldItem.line,
            section: `CLI Box ${oldItem.line} - Line ${lineIndex + 1}`,
            field: `lineValues[${lineIndex}].ngnValue`,
            oldValue: oldLine.ngnValue,
            newValue: newLine.ngnValue,
            message: `CLI Box ${oldItem.line} - Line ${
              lineIndex + 1
            }: ${ngnChanges.join(", ")}`,
            timestamp: Date.now(),
            changedBy: "Sales Agent",
          });
        }
      }
    });
  });

  return changes;
};

const compareTopLevelKeys = (oldData, newData, changedBy) => {
  let changes = [];

  oldData.forEach((oldItem, index) => {
    let newItem = newData[index];
    if (!newItem) return; // If newItem is missing, skip

    // Compare Primitive Values
    changes.push(
      ...comparePrimitiveValues(
        oldItem,
        newItem,
        oldItem.line,
        changedBy,
        index + 1
      )
    );

    // Compare Nested Objects
    changes.push(
      ...compareNestedObjects(
        oldItem,
        newItem,
        oldItem.line,
        changedBy,
        index + 1
      )
    );
  });

  // changes.push(...compareLineValues(oldData, newData));

  return changes;
};

// const compareTopLevelKeys = (oldData, newData, changedBy) => {
//   let changes = [];

//   const MAIN_KEY = {
//     mobileNo: "CLI Phone Number",
//     cliNumber: "CLI Option",
//     line: "No of Line",
//   };

//   const NESTED_KEY = {
//     "legacyTariff.isSelected": "Legacy Option",
//     "digitalTariff.isSelected": "Digital/NGN Option",
//     "additionalService.isSelected": "Additional Services",
//     "differentAddress.isSelected": "Different Address Option",
//     "upgradeCharge.isSelected": "Upgrade Charge",
//     "migration.isSelected": "Migration Option",
//     "transfer.isSelected": "Transfer Option",
//     "transfer.attachedValue": "Transfer Type",
//   };

//   // Recursive function to compare objects at all levels
//   const compareObjects = (oldObj = {}, newObj = {}, parentKey = "", line) => {
//     Object.keys({ ...oldObj, ...newObj }).forEach((key) => {
//       const fullKey = parentKey ? `${parentKey}.${key}` : key;
//       const readableKey = MAIN_KEY[key] || NESTED_KEY[fullKey] || fullKey;

//       if (
//         typeof newObj[key] === "object" &&
//         newObj[key] !== null &&
//         !Array.isArray(newObj[key])
//       ) {
//         compareObjects(oldObj[key] || {}, newObj[key], fullKey, line);
//       } else if (oldObj[key] !== newObj[key]) {
//         let message = `CLI Box ${line}: ${readableKey} changed from ${
//           oldObj[key] === undefined ? "None" : oldObj[key]
//         } to ${newObj[key] === undefined ? "None" : newObj[key]}`;

//         if (fullKey.endsWith(".isSelected")) {
//           message = `CLI Box ${line}: ${readableKey} changed from ${
//             oldObj[key] ? "Selected" : "Not Selected"
//           } to ${newObj[key] ? "Selected" : "Not Selected"}`;
//         }

//         changes.push({
//           cliBox: line,
//           section: `Cli Box ${line}`,
//           field: readableKey,
//           oldValue: oldObj[key] || "None",
//           newValue: newObj[key] || "None",
//           message,
//           timestamp: Date.now(),
//           changedBy,
//         });
//       }
//     });
//   };

//   // Compare each CLI Box
//   oldData.forEach((oldItem, index) => {
//     let newItem = newData[index];
//     if (!newItem) return;
//     compareObjects(oldItem, newItem, "", oldItem.line);
//   });

//   return changes;
// };

const dateChangesLog = (oldData, newData, changedBy) => {
  const KEYS_TEXT = {
    contractSignedDate: "Contract Signed Date",
  };

  let changes = [];

  Object.keys(newData).forEach((key) => {
    if (oldData[key] !== newData[key]) {
      changes.push({
        section: "Dates",
        field: key,
        oldValue: oldData[key] || "Empty",
        newValue: newData[key] || "Empty",
        message: `${KEYS_TEXT[key]} changed from ${
          oldData[key] || "Empty"
        } to ${newData[key] || "Empty"}`,
        timestamp: Date.now(),
        changedBy,
      });
    }
  });

  return changes;
};

export {
  getRouterChangesLog,
  getGeneralInfoChangesLog,
  getCordedChangesLog,
  getCordedlessChangesLog,
  getDownlaodSpeedChangesLog,
  getUploadSpeedChangesLog,
  getEquipmentChangesLog,
  ebillingChangesLog,
  debitDetailsChangesLog,
  debitDetailsValueChangesLog,
  upfrontPaymentChangesLog,
  followUpAndEndDateChangesLog,
  compareTopLevelKeys,
  dateChangesLog
};
